// productParameterUtils.ts
interface ProductParameter {
    productId: string;
    qtyOrdered: number;
    unitOfMeasure: string;
    properties: {
        spoolSelected: number;
    };
}

interface Parameter {
    productId: string;
    qtyOrdered?: number;
    unitOfMeasure?: string;
    numberOfSpools?: number;
}

export const createProductParameter = (parameter: Parameter): ProductParameter | null => {
    if (!parameter.unitOfMeasure || !parameter.numberOfSpools) {
        return null;
    }

    return {
        productId: parameter.productId,
        qtyOrdered: parameter.qtyOrdered ?? 1,
        unitOfMeasure: parameter.unitOfMeasure,
        properties: {
            spoolSelected: parameter.numberOfSpools,
        },
    };
};
